import { Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import Header from './components/Header/Header';
import Home from './components/Home/Home';
import About from './components/About/About';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import NoMatch from './components/NotFound/NoMatch';
import DarkProvider from '../src/store/DarkProvider'

function App() {

  return (
    <DarkProvider>
        <Header />
        <Routes>
          <Route path='/' element={<Navigate replace to='/home' />} />
          <Route path='/home' element={<Home />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/about' element={<About />} />
          <Route path="*" element={<NoMatch />} />
        </Routes>
        <Footer />
    </DarkProvider>
  );
}

export default App;
